export default __webpack_public_path__ + "static/media/Eye_5_F_C4.15a16c3a.svg";